import logo from './logo.svg';
// import './App.css';

function App() {
  return (
    <div className="privacy-policy-container" style={{ padding: '20px' }}>
      <h1>Privacy Policy</h1>
      <p><strong>App Name:</strong> HR ROLL</p>
      <p><strong>Developer / Company Legal Name:</strong> Solutions Circle</p>
      <p>Last updated: December 30, 2024</p>

      <p>
        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
      </p>
      <p>
        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
        This Privacy Policy has been created with the help of the <a href="https://www.freeprivacypolicy.com/free-privacy-policy-generator/" target="_blank" rel="noopener noreferrer">Free Privacy Policy Generator</a>.
      </p>

      <h2>Background Location Data Disclosure</h2>
      <p>
        HR ROLL collects location data in the background to enable automatic attendance tracking and accurate check-in/check-out, even when the app is closed or not in use. This data is essential to the core functionality of the app, which is to track attendance and employee location history during working hours.
      </p>
      <p>
        The app will not collect background location data unless the user has granted explicit permission. Users are informed about this usage clearly during onboarding and can change their preferences at any time through device settings.
      </p>

      <h2>Interpretation and Definitions</h2>
      <h3>Interpretation</h3>
      <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
      <h3>Definitions</h3>
      <p>For the purposes of this Privacy Policy:</p>
      <ul>
        <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
        <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party...</li>
        <li><strong>Application</strong> refers to HR ROLL, the software program provided by the Company.</li>
        <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Attendance.</li>
        <li><strong>Country</strong> refers to: Saudi Arabia</li>
        <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
        <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
        <li><strong>Service</strong> refers to the Application.</li>
        <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company...</li>
        <li><strong>Usage Data</strong> refers to data collected automatically...</li>
        <li><strong>You</strong> means the individual accessing or using the Service...</li>
      </ul>

      <h2>Collecting and Using Your Personal Data</h2>
      <h3>Types of Data Collected</h3>
      <h4>Personal Data</h4>
      <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information...</p>
      <ul>
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Phone number</li>
        <li>Address, State, Province, ZIP/Postal code, City</li>
        <li>Location, Background location (while check-in and stop tracking background location while check-out)</li>
        <li>Usage Data</li>
      </ul>

      <h4>Usage Data</h4>
      <p>Usage Data is collected automatically when using the Service...</p>

      <h4>Information Collected while Using the Application</h4>
      <p>While using Our Application, in order to provide features of Our Application, We may collect, with Your prior permission:</p>
      <ul>
        <li>Information regarding your location</li>
      </ul>
      <p>We use this information to provide features of Our Service...</p>

      <h3>Use of Your Personal Data</h3>
      <p>The Company may use Personal Data for the following purposes:</p>
      <ul>
        <li><strong>To provide and maintain our Service</strong></li>
        <li><strong>To manage Your Account</strong></li>
        <li><strong>For the performance of a contract</strong></li>
        <li><strong>To contact You</strong></li>
        <li><strong>To provide You</strong> with news, special offers...</li>
        <li><strong>To manage Your requests</strong></li>
        <li><strong>For business transfers</strong></li>
        <li><strong>For other purposes</strong></li>
      </ul>

      <p>We may share Your personal information in the following situations:</p>
      <ul>
        <li><strong>With Service Providers</strong></li>
        <li><strong>For business transfers</strong></li>
        <li><strong>With Affiliates</strong></li>
        <li><strong>With business partners</strong></li>
        <li><strong>With other users</strong></li>
        <li><strong>With Your consent</strong></li>
      </ul>

      <h3>Retention of Your Personal Data</h3>
      <p>The Company will retain Your Personal Data only for as long as is necessary...</p>

      <h3>Transfer of Your Personal Data</h3>
      <p>Your information, including Personal Data, is processed at the Company's operating offices...</p>

      <h3>Delete Your Personal Data</h3>
      <p>You have the right to delete or request that We assist in deleting the Personal Data...</p>

      <h3>Disclosure of Your Personal Data</h3>
      <h4>Business Transactions</h4>
      <p>If the Company is involved in a merger, acquisition or asset sale...</p>
      <h4>Law enforcement</h4>
      <p>Under certain circumstances, the Company may be required to disclose Your Personal Data...</p>
      <h4>Other legal requirements</h4>
      <p>The Company may disclose Your Personal Data in the good faith belief...</p>

      <h3>Security of Your Personal Data</h3>
      <p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet...</p>

      <h2>Children's Privacy</h2>
      <p>Our Service does not address anyone under the age of 13...</p>

      <h2>Links to Other Websites</h2>
      <p>Our Service may contain links to other websites that are not operated by Us...</p>

      <h2>Changes to this Privacy Policy</h2>
      <p>We may update Our Privacy Policy from time to time...</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, You can contact us:</p>
      <ul>
        <li>By email: <a href="mailto:info@sccsaudi.com">info@sccsaudi.com</a></li>
      </ul>
    </div>
  );
}

export default App;
